<template>
    <transition name="slide-bar">
        <div v-if="topNotification.show" class="top-notification" :class="topNotification.type">
            <Icon :icon-name="topNotification.icon" />
            <div v-html="topNotification.text" />
        </div>
    </transition>
    <div class="new-modal-header-wrapper" :class="[{'has-tabs': hasTabPillsSlot,'has-steps':hasStepsSlot, 'dark': darkScheme}, modalSize, variant]">
        <div class="new-modal-header">
            <div class="new-modal-title">
                {{ title }}
                <slot name="titlePill"></slot>
            </div>
            <div class="right-side">
                <div v-if="hasHeaderPill" class="new-modal-header-pill-container">
                    <slot name="headerPill"></slot>
                </div>
                <Cta v-if="modalSize !== 'small'" :dark-scheme="darkScheme" :type="'icon subtle no-bg'" @click="closeModal()">
                    <Icon icon-name="close" alt="Close modal" :width="24" :height="24"/>
                </Cta>
            </div>
        </div>

        <div v-if="description" class="new-modal-description" v-html="description" />

        <div v-if="hasTabPillsSlot" class="new-modal-tabs-container">
            <slot name="tabPills"></slot>
        </div>

        <div v-if="hasStepsSlot" class="new-modal-step-container">
            <slot name="steps"></slot>

        </div>
    </div>
</template>

<script>
import Icon from "../../common/Icon.vue";
import Cta from "../../common/components/CtaButton.vue";
import {ModalTopNotificationType} from "@/scripts/common/enums.js";

export default {
    name: 'modal-header',
    components: {Cta, Icon},
    inject: ['modalSize'],
    props: {
        title: {
            default: null,
            type: String
        },
        description: {
            default: null,
            type: String
        },
        darkScheme: {
            default: false,
            type:Boolean
        },
        hasTabPills: {
            type: Boolean,
            default: null
        },
        variant: {
            type: String,   //  "section-settings"
            default: null,
        },
        topNotification: {
            type:Object,
            default: () => { return {show: false, text: "", type: ModalTopNotificationType.INFO, icon:""} }
        }
    },
    methods: {
        closeModal() {
            this.$emit('close');
            this.$parent.$emit('close');
        },
    },
    computed: {
        hasTabPillsSlot() {
            if (this.hasTabPills !== null) return this.hasTabPills;
            return !!this.$slots.tabPills;
        },
        hasStepsSlot() {
            return !!this.$slots.steps
        },
        hasHeaderPill() {
            return !!this.$slots.headerPill
        },
    },
}
</script>

<style>
.top-notification {
    left: 50%;
    transform: translate(-50%, -51px);
    will-change: transform;
}

.slide-bar-enter-active,
.slide-bar-leave-active {
    transition: transform 0.3s ease;
}

.slide-bar-enter-from,
.slide-bar-leave-to {
    transform: translate(-50%, 0);
}

.slide-bar-enter-to,
.slide-bar-leave-from {
    transform: translate(-50%, -51px);
}
</style>

<style lang="scss" scoped>
.top-notification {
    display: flex;
    width: 90%;
    padding: 12px 30px 12px 30px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    border-radius: 8px 8px 0 0;
    background: var(--mint20);
    font: var(--editor-ui-b2-regular);
    color: var(--asphalt70);
    top: 4px;
    position: absolute;
    z-index: -2;
    margin: 0 auto;

    .bold {
        font: var(--editor-ui-b2-semibold);
        color: var(--asphalt90);
    }

    svg {
        color: var(--mint60);
        width: 24px;
        height: 24px;
    }

    &.info {
        background: var(--asphalt20);
        font: var(--editor-ui-b2-regular);

        svg {
            color: var(--statis100);
        }

    }

    &.warning {
        background: var(--rose20);
        font: var(--editor-ui-b2-regular);

        svg {
            color: var(--rose60);
        }

    }
}

.new-modal-header-wrapper {
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding: 24px;
    border-bottom: 1px solid var(--modal-border);
    position: relative;
    z-index: 1;
    background-color: var(--modal-bg);
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;

    .new-modal-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        z-index: 2;

        .new-modal-title {
            display: flex;
            align-items: center;
            gap: 8px;

            font: var(--editor-ui-h2);
            color: var(--modal-title);
        }

        .right-side {
            display: flex;
            flex-direction: row;
            gap: 8px;
        }
    }

    .new-modal-description {
        font: var(--editor-ui-b2-regular);
        color: var(--modal-description);
        letter-spacing: 0.14px;

        :deep(.bold) {
            font: var(--editor-ui-b2-semibold);
        }
    }
    .new-modal-tabs-container {
        width: 100%;
    }

    &.has-tabs {
        padding: 24px 24px 0;
    }

    &.has-steps {
        border-bottom: none;
        gap: 20px;
        padding: 24px 24px 0;
    }

    &.small {
        padding: 32px 32px 16px 32px;
        border-bottom: none;
        .new-modal-header {
            justify-content: center;
            text-align: center;
            .new-modal-title {
                font: var(--editor-ui-h1);
            }
            .new-modal-description {
                font: var(--editor-ui-b1-regular);
                letter-spacing: 0.16px;
            }
        }
    }

    &.section-settings {
        .new-modal-title {
            font: var(--editor-ui-h3);
        }
    }

}
</style>
